{
  "generel": {
    "yes": "Ja",
    "no": "Nein"
  },
  "actions": {
    "cancel": "Abbrechen",
    "choose_images": "Wähle eines oder mehrere Bilder aus, welche Du zu diesem Eintrag hinzufügen möchtest.",
    "choose_image": "Füge ein Bild zu diesem Eintrag hinzu.",
    "choose_camera": "Kamera",
    "choose_photo": "Wähle ein Foto aus",
    "choose_library": "Library",
    "add_additional_information": "Fülle folgende Felder nach deinem Stand des Wissens aus, du kannst sie aber auch überspringen indem du auf 'Weiter' klickst",
    "delete": "Löschen",
    "dont_show_again": "Nicht mehr anzeigen",
    "edit": "Bearbeiten",
    "edit_details": "Details bearbeiten",
    "next": "Weiter",
    "finish": "Meldung abschliessen",
    "ok": "OK",
    "previous": "Zurück",
    "show": "Ansehen",
    "upload": "Hochladen",
    "preview": "Vorschau einblenden",
    "preview_hide": "Vorschau ausblenden",
    "submit": "Absenden",
    "location_submit": "Leerstand eintragen",
    "add_images_addtional_info": "Weitere Informationen eintragen",
    "update": "Aktualisieren",
    "take_picture": "Mach ein Foto",
    "use_slider": "Benutze den Schieberegler",
    "abort": "Abbrechen",
    "close": "Schliessen",
    "more": "Weitere Einträge laden",
    "back": "Zurück",
    "update_available": "Eine aktualisierte Version ist verfügbar. Klicke auf den Neuladen Knopf zum aktualisieren.",
    "reload": "Neuladen",
    "password_request_received": "Deinen Anfrage wurde erhalten. Sollte die Email in unserer Datenbank sein erhälst du eine Email.",
    "comment_created": "Kommentar wurde erstellt.",
    "comment_updated": "Kommentar wurde aktualisiert."
  },
  "table": {
    "rowsPerPage": "Einträge pro Seite",
    "pageOf": "von"
  },
  "admin": {
    "dashboard": "Dashboard",
    "menu": "Menü"
  },
  "map": {
    "WindowsHelpText": "Benutze Strg + um die Karte zu bewegen.",
    "MacHelpText": "Benutze ⌘ + um die Karte zu bewegen.",
    "MobileHelpText": "Benutze zwei Finger um die Karte zu bewegen"
  },
  "menu": {
    "imprint": "Impressum",
    "admin": "Administration",
    "map": "Karte",
    "user": "Benutzer*in",
    "profil": "Einstellungen & Einträge",
    "content": "Informationen/Inhalte",
    "statistic": "Statistik",
    "detail": "Leerstand",
    "news": "Neuigkeiten",
    "article": "Artikel",
    "form": "Leerstand melden",
    "form_edit": "Leerstand bearbeiten",
    "create": "Leerstand erstellen",
    "search": "Suche",
    "my-locations": "Meine Leerstände",
    "profile": "Einstellungen",
    "styleguide": "Styleguide",
    "content_menu": {
      "about": "Über das Projekt",
      "about-project": "Der Leerstandsmelder",
      "about-network": "Das Netzwerk",
      "about-history": "Gründung und Geschichte",
      "about-opensource": "OpenSource",
      "about-partner": "Unsere Partner*innen",
      "claim": "Unsere Forderungen",
      "claim-general": "Allgemein",
      "claim-regional": "Regional",
      "definition": "Was ist Leerstand",
      "definition-definition": "Definition",
      "definition-legal": "Rechtliche Lage",
      "definition-term": "Fristen der Städte & Regionen",
      "definition-reasons": "Gründe für Leerstand",
      "definition-harm": "Warum Leerstand schadet",
      "definition-spot": "Wie erkenne ich Leerstand",
      "perspective": "Perspektiven",
      "perspective-experience": "Praxis",
      "perspective-theory": "Theorie",
      "howto": "Anleitung",
      "demands": "Unsere Forderungen",
      "glossar": "Glossar & Perspektiven",
      "participate": "Mitmachen",
      "participate-how": "Wie mitmachen?",
      "participate-material": "Material",
      "participate-idea": "Ideen",
      "participate-donation": "Spenden",
      "press": "Presse",
      "press-press": "Pressesammlung",
      "help": "Hilfe & Support",
      "support": "Hilfe & Support",
      "support-howto": "So geht's",
      "support-faq": "FAQ",
      "support-goodtoknow": "Gut zu wissen",
      "contact": "Kontakt",
      "contact-contact": "Kontakt",
      "contact-dataprotection": "Datenschutz",
      "contact-terms": "Nutzungsbedingungen",
      "contact-imprint": "Impressum"
    },
    "admin_menu": {
      "dashboard": "Dashboard",
      "regions": "Regionen",
      "users": "Benutzer*innen",
      "locations": "Leerstände"
    }
  },
  "assets": {
    "file": "Datei"
  },
  "author": {
    "author": "Autor",
    "by": "von",
    "created": "Erstellt",
    "in": "in",
    "on": "am",
    "updated": "Aktualisiert"
  },
  "captcha": {
    "enter_captcha": "Gib den Code ein"
  },
  "stats": {
    "location_created_month": "Leerstand: Erstellt in Jahren",
    "location_updated_month": "Leerstand: Aktualisert in Jahren",
    "location_postcode": "Leerstand: Nach Postzeitzahl",
    "location_buildingType": "Leerstand: Gebäudetyp",
    "location_owner": "Leerstand: Eigentümer"
  },
  "comments": {
    "load_success": "Kommentar geladen",
    "all": "Kommentare",
    "manage_comments": "Kommentare verwalten",
    "update_comment": "Kommentar verwalten",
    "additional_information": "Weitere Informationen",
    "comment": "Kommentar",
    "comment_plural": "Kommentare",
    "comment_text": "Kommentartext",
    "new_comment": "Neue Informationen",
    "new_comment_explain": "Hast du neue Informationen zu diesem Objekt?",
    "edit_comment": "Kommentar bearbeiten",
    "edit_comment_explain": "Überarbeite hier deinen Kommentar.",
    "new_comment_login": "Melde Dich an, um einen neuen Kommentar zu schreiben.",
    "no_comments": "Keine Kommentare",
    "body": "Nachricht",
    "images": "Bilder",
    "hidden": "Kommentar ausblenden",
    "restart": "Neuen Kommentar eingeben",
    "restart_explain": "Um einen weiteren Kommentar anzulegen, fang hier wieder an.",
    "saved": "Deine Kommentar wurde gespeichert",
    "created": "Erstellt",
    "status": "Zustand",
    "status_explain": "Änderung am Zustand",
    "status_options": {
      "vacant": "Leerstand",
      "demolished": "Abgerissen",
      "reconstruction": "Neubau",
      "rent": "Vermietet",
      "temporary": "Zwischennutzung",
      "construction": "Bauarbeiten"
    }
  },
  "creator": {
    "tabs": {
      "admin": "Verwaltung",
      "details": "Details",
      "info": "Info",
      "location": "Ort",
      "preview": "Vorschau"
    }
  },
  "errors": {
    "access_denied": "Du hast keine Berechtigung, um diese Aktion auszuführen.",
    "authorization_failed": "Anmeldung fehlgeschlagen.",
    "location": {
      "no_data": "Leerstand konnte nicht geladen werden."
    },
    "region": {
      "no_data": "Region konnte nicht geladen werden."
    },
    "unknown": "Ein unbekannter Fehler ist aufgetreten.",
    "noconnection": "Die Anwendung konnte keine Verbindung zum Server herstellen. Probiere es zu einem späteren Zeitpunkt noch einmal.",
    "critical": {
      "title": "Mieser Fehler",
      "resolve": "Ok, neu starten?"
    },
    "not_found": {
      "title": "404",
      "teaser": "Diese Seite konnte nicht gefunden werden.",
      "goto_start": "Zurück zum Start!"
    },
    "users": {
      "confirmation_failed": "Bestätigung fehlgeschlagen. Möglicherweise wurde dieser Link bereits verwendet.",
      "email_exists": "E-Mail Adresse existiert bereits",
      "invalid_email": "Ungültige E-Mail Adresse",
      "password_confirm_mismatch": "Passwörter stimmen nicht überein.",
      "password_too_short": "Passwort ist zu kurz (min. 8 Zeichen).",
      "reset_failed": "Passwort Zurücksetzen fehlgeschlagen. Dieser Link ist nicht (mehr) gültig.",
      "too_many_failed_logins": "Zu viele fehlgeschlagene Anmeldungen. Versuche es in fünf Minuten wieder.",
      "password": {
        "generall": "Ein Fehler ist aufgetreten. Bitte wende dich an unser Support Team.",
        "email_valid": "UNgültige Email. Bitte wende dich an unser Support Team."
      },
      "register": {
        "name_required": "Benutzername muss ausgefüllt werden",
        "name_lesser": "Benutzername darf nicht länger als 30 Zeichen sein",
        "name_greater": "Benutzername muss länger als 3 Zeichen sein",
        "email_required": "E-Mail muss ausgefüllt werden",
        "email_valid": "E-Mail muss valide sein",
        "password_required": "Passwort muss ausgefüllt werden",
        "password_greater": "Passwort muss länger als 6 Zeichen sein",
        "password_match": "Passwörter müssen übereinstimmen",
        "password_confirmation_required": "Passwort (Wiederholung) muss ausgefüllt werden",
        "accept_terms_required": "Den AGBs muss zugestimmt werden",
        "accept_no_minor_required": "Du muss versichern das du über 18 Jahre alt bist.",
        "general_error": "Bei der Registierung ist ein Fehler aufgetreten. Ggf. gibt es bereits ein Konto? Bitte wende dich an unser Support Team."
      }
    }
  },
  "successes": {
    "user": {
      "login": "Du hast dich erfolgreich angemeldet.",
      "logout": "Du hast dich erfolgreich abgemeldet."
    }
  },
  "photos": {
    "remove_confirm_title": "Bild löschen?",
    "remove_confirm_body": "Bist du dir wirklich ganz sicher das du das Bild löschen willst?",
    "remove_success": "Das Bild wurde gelöscht"
  },
  "locations": {
    "manage_locations": "Leerstände verwalten",
    "new_locations": "Neuste Leerstände",
    "notification": "Meldung",
    "status": "Aktueller Stand",
    "error": "Allgemeiner Fehler: ",
    "saved": "Leerstand gespeichert",
    "restart_explain": "Dein Eintrag wurde gespeichert. Bitte ergänze den Eintrag noch mit weiteren Informationen und füge auch Bilder hinzu.",
    "restart": "Weiteren Eintrag anlegen",
    "location_create": "Leerstand eintragen",
    "location_exists": "Gemeldeter Leerstand",
    "location_not_exists": "Neue Adresse",
    "location_edit_existing": "Bestehenden Eintrag ergänzen",
    "create_explain_1": "Gib hier eine Adresse ein...",
    "create_explain_2": "Um einen Leerstand einzutragen muss du eine Adresse angeben. Nutze dafür das Suchfeld oder verschiebe die Karte.",
    "create_explain_or": "ODER",
    "create_explain_3": "... oder bewege die Karte um einen Adresse zu suchen",
    "create_explain_4": "Ihr könnt auch die Karte verwenden um eine Adresse auswählen.",
    "image_upload": "Bilder hochladen (optional)",
    "additional_information": "Weitere Informationen (optional)",
    "status_entry": {
      "vacancy": "Leerstand",
      "damage": "Abgerissen",
      "reconstruction": "Neubau",
      "alive": "Bewohnt",
      "temporary": "Zwischenutzung",
      "construction": "Bauarbeiten",
      "unknown": "Unklarer Zustand",
      "undefined": "Undefiniert"
    },
    "stepper": {
      "step1": "Adresse eintragen",
      "step2": "Bilder hochladen / Weitere Informationen",
      "step3": "Vorschau / Zusammenfassung"
    },
    "status_explain": "Wie ist der aktuelle Status zu dem Leerstand",
    "timeline_explain": "Hier siehst du die Entwicklung des Status",
    "address": "Adresse",
    "building": "Gebäude",
    "building_type": "Gebäudeart",
    "building_type_explain": "Was ist oder war der Nutzen des Gebäudes? Es können mehrere Merkmale ausgewählt werden.",
    "building_type_options": {
      "residential": "Wohngebäude",
      "commercial": "Gewerblich",
      "industrial": "Industriell",
      "historical": "Historisch",
      "public_work": "Öffentlich",
      "other": "andere"
    },
    "city": "Stadt",
    "create_new": "Leerstand melden",
    "update_location": "Leerstand aktualisieren",
    "degree": "Grad des Leerstands",
    "degree_options": {
      "complete": "Vollständig",
      "partial": "Teilweise"
    },
    "description": "Beschreibung",
    "description_explain": "Ist dir noch etwas aufgefallen, was bisher noch nicht abgefragt wurde? Hast du weitere Informationen über das Gebäude? Möchtest du die Community auf etwas hinweisen?",
    "demolished": "Abgerissen",
    "demolished_yes": "Ja",
    "demolition_options": {
      "rumor": "Gerüchte",
      "demolished": "Abgerissen"
    },
    "demolition_rumor": "Abrissgerüchte",
    "demolition_rumor_yes": "Ja",
    "edit": "Leerstand bearbeiten",
    "empty_for": "Leer seit",
    "empty_options": {
      "recently": "Kurzem",
      "min_five_years": "wenigstens fünf Jahren",
      "min_three_years": "wenigstens drei Jahren",
      "min_one_year": "wenigstens einem Jahr",
      "about_half_year": "ungefähr einem halben Jahr",
      "less_than_one_quarter_year": "weniger als ein viertel Jahr",
      "less_than_one_half_year": "wengier als ein halbes Jahr",
      "less_than_three_quarters_year": "weniger als ein dreiviertel Jahr",
      "less_than_one_year": "weniger als ein Jahr",
      "more_than_ten_years": "mehr als zehn Jahre",
      "one_quarter": "ein viertel",
      "one_half": "one halbes",
      "three_quarters": "dreiviertel",
      "year": "Jahr",
      "year_plural": "Jahre",
      "and": "und"
    },
    "help": {
      "info": "Gib hier einen aussagekräftigen Titel und eine Beschreibung für diesen Leerstand ein.",
      "location": "Gib eine Adresse ein und die Karte sollte sich nach einem kurzen Moment aktualisieren. Du kannst den Marker auf der Karte ziehen, um damit die Adresse zu aktualisieren.",
      "details": "Trag ein, welche Details dir über den Leerstand bekannt sind. Wenn Du etwas nicht weißt, lass es einfach unausgewählt.",
      "admin": "Setz das Häkchen auf \"Ausgeblendet\" um es für nicht-Administratoren unsichtbar zu machen."
    },
    "published": "Veröffentlicht",
    "featured": "Hervorgehoben",
    "hidden": "Ausgeblendet",
    "hidden_yes": "Ja",
    "hidden_moderation": "Vielen Dank für Deine Meldung ! Der Beitrag wir in den nächsten Tagen freigeschaltet. Bitte bleib an dem Objekt dran und ergänze den Eintrag alle 3 Monate mit einem Kommentar, um Veränderungen oder Stillstand zu dokumentieren.",
    "location": "Leerstand",
    "location_photos": "Fotos zu diesem Leerstand",
    "location_plural": "Leerstände",
    "locations_by_region": "Leerstände nach Region",
    "my_locations": "Meine Leerstände",
    "my_comments": "Meine Kommentare",
    "no_recent_activity": "Keine Leerstände",
    "no_recent_comments": "Keine Kommentare erstellt",
    "none_found": "Keine Leerstände gefunden.",
    "owner": "Eigentümer",
    "owner_explain": "Was weisst du über die Eigentümer*in? Beschränke dich auf eine Möglichkeit.",
    "owner_options": {
      "private": "Privat",
      "business": "Gewerblich",
      "public": "Öffentlich",
      "city": "Stadt"
    },
    "owner_company": "Firma oder Organisation",
    "owner_company_explain": "Firma oder Organisation die der Eigentümer ist.",
    "owner_company_label": "Firma oder Organisation",
    "usage": "Nutzung",
    "usage_explain": "Was weisst du über die Nutzung der leerstehenden Fläche?",
    "usage_options": {
      "living": "Wohnfläche",
      "business": "Gewerbefläche",
      "other": "Andere"
    },
    "part": "Bereich",
    "part_explain": "Was weisst du über die Nutzung der leerstehenden Fläche?",
    "part_options": {
      "front": "Vorderhaus",
      "back": "Hinterhaus/Gartenhaus",
      "side": "Seitenflügel"
    },
    "epoche": "Kategorie des Leerstands",
    "epoche_explain": "In welche der folgenden Kategorien lässt sich der Leerstand einsortieren? Altbauten erkennt man an den historischen, oft verschnörkelten Fassaden und hohen Decken, während Neubauten durch moderne, klare Linien auffallen.",
    "epoche_options": {
      "old": "Altbau",
      "new": "Neubau"
    },
    "floors": "Stockwerke des Gebäudes",
    "floors_explain": "Wieviele Stockwerke hat das Gebäude in dem sich der Leerstand befindet?",
    "floors_label": "Anzahl der Stockwerke",
    "postcode": "Postleitzahl",
    "postcode_short": "Plz",
    "borough": "Bezirk",
    "suburb": "Stadtteil",
    "recent_activity": "Neueste Aktivitäten",
    "remove_confirm_title": "Leerstand löschen",
    "remove_confirm_body": "Diese Aktion kann nicht rückgängig gemacht werden. Bist Du sicher?",
    "remove_success": "Leerstand wurde gelöscht",
    "load_success": "Leerstand wurde geladen",
    "search": "Suchen",
    "street": "Straße",
    "road": "Straße",
    "house_number": "Nr.",
    "title": "Titel",
    "unknown": "Unbekannt",
    "images": "Bilder",
    "reported_by": "von",
    "reported_at": "am",
    "sensitiv": "Sensibler Ort",
    "latitude": "Breitengrad",
    "longitued": "Längengrade",
    "country": "Land",
    "country_code": "Landskürzel",
    "dated": "datiert",
    "filtered": "gefiltert"
  },
  "search": {
    "start_typing": "Suche starten",
    "nothing_found": "Bisher wurden keine Ergebnisse gefunden"
  },
  "messages": {
    "introduction_explain_headline": "Mach mit uns den Leerstand in deiner Stadt sichtbar",
    "introduction_explain_content": "Finde und melde Leerstände in deiner Region",
    "introduction_explain_content_alt": "Werde Leerstandsmelder*in",
    "regions_map_intro": "Von Amsterdam bis Wuppertal, alle Leerstände auf einen Blick:",
    "staging_message": "Ihr befindet euch auf einer Test/Staging Plattform. Bitte gebt keinen Daten ein, da diese regelmässig gelöscht werden. Falls ihr einen Leerstand melden wollt, besucht bitte unsere weiterhin produktive Seite: https://leerstandsmelder.de",
    "answer_message": "Nachricht beantworten",
    "create_message": "Nachricht erstellen",
    "message": "Nachricht",
    "message_text": "Nachricht",
    "my_messages": "Nachrichten",
    "sent": "Gesendet",
    "to": "An",
    "from": "Von",
    "comments": {
      "create_success": "Kommentar erfolgreich gespeichert."
    },
    "locations": {
      "create_success": "Leerstand erfolgreich eingetragen.",
      "update_success": "Leerstand erfolgreich aktualisiert.",
      "status_address_missing": "Bitte Adresse & Status ausfüllen",
      "not_yet_published": "Der Eintrag muss noch veröffentlicht werden, bevor er auf der Karte dargestellt wird.",
      "region_moderated": "Diese Region wird moderiert. Deine Einträge werden von einem ehrenamtlichen Moderator-Team freigeschaltet. Dieses kann einige Zeit in Anspruch nehmen."
    },
    "images": {
      "save_success": "Bild erfolgreich gespeichert."
    },
    "users": {
      "confirmation_success": "Deine E-Mail wurde erfolgreich bestätigt. Du bist jetzt eingeloggt!",
      "create_success": "Deine Registrierung war erfolgreich. Du solltest jetzt eine E-Mail mit einem Bestätigungslink erhalten.",
      "request_reset_success": "Du solltest nun eine E-Mail erhalten, die einen Link zum Zurücksetzen Deines Passworts enthält.",
      "reset_success": "Du bist nun eingeloggt und kannst Dein Passwort ändern.",
      "update_success": "Konto wurde erfolgreich aktualisiert.",
      "password_change_success": "Dein Passwort wurde aktualisiert",
      "password_change_error": "Dein Passwort konnte nicht aktualisiert werden. Wende dich an das Support-Team.",
      "delete_success": "Dein Benutzerkonto wurde gelöscht"
    },
    "login": {
      "failed_authentication": "Dein Anmeldung konnte nicht überprüft werden. Unser System nutzt eine neue Verschlüsselung. Bitte setze dein Passwort neu über den 'Passwort vergessen' Prozess.",
      "failed_user": "Dein Anmeldung konnte nicht überprüft werden."
    }
  },
  "popups": {
    "relaunch": {
      "title": "Relaunch!"
    }
  },
  "posts": {
    "edit_post": "Eintrag bearbeiten",
    "manage_posts": "Einträge verwalten",
    "post": "Eintrag",
    "post_plural": "Einträge",
    "site_post_plural": "Seiteninhalte",
    "title": "Titel",
    "update_success": "Eintrag erfolgreich aktualisiert..",
    "create_post": "Eintrag erstellen",
    "slug": "Kurzform URL",
    "remove_confirm_title": "Eintrag/Seiteninhalt löschen",
    "remove_confirm_body": "Diese Aktion kann nicht rückgängig gemacht werden. Bist Du sicher?",
    "remove_success": "Eintrag/Seiteninhalt wurde gelöscht",
    "static": "Statische Seite"
  },
  "news": {
    "new_articles": "Neuigkeiten"
  },
  "regions": {
    "settings": "Einstellungen",
    "hide_message": "Nachricht, wenn Region nicht angezeigt wird",
    "latitude": "Breitengrad",
    "longitude": "Längengrad",
    "manage_regions": "Regionen verwalten",
    "create_regions": "Region erstellen",
    "region": "Region",
    "region_plural": "Regionen & Städte",
    "region_detail": "Region anzeigen",
    "region_select": "Region auswählen",
    "set_hide": "Diese Region nicht anzeigen",
    "set_moderate": "Diese Region moderieren",
    "title": "Titel",
    "load_success": "Region erfolgreich geladen",
    "update_success": "Region erfolgreich aktualisiert",
    "update_error": "Region konnte nicht aktualisiert werden",
    "create_success": "Region erfolgreich erstellt",
    "create_error": "Region konnte nicht erstellt werden",
    "zoom": "Zoom",
    "count": "Anzahl",
    "created": "Erstelllt",
    "updated": "Aktualisiert",
    "filter": "Filter / Zeitstrahl",
    "location_explain": "Hier kann der Standort und Mittelpunkt der Region ausgewählt werden",
    "additional_information": "Weitere Informationen",
    "subtitle_explain": "Hier kann ein Untertitel für die Region angegeben werden",
    "subtitle": "Untertitel",
    "description_explain": "Hier kann ein Beschreibung für die Region angegeben werden",
    "description": "Beschreibung",
    "moderations": "Einstellungen zur Moderation",
    "moderate_message": "Nachricht, wenn eine Leerstand in einer moderierten Region eingestellt wird und erst durch die Moderation freigeschaltet werden muss.",
    "legal": "Rechtliche Struktur und Hintergünde",
    "legal_explain": "Hier können INformationen zur juristisch zuständigen Orgaisation oder Person hinterlegt werden.",
    "organisation": "Name der verantwortlichen Organisation/Person",
    "organisation_email": "Kontakt-Email",
    "organisation_url": "Kontakt-Link",
    "organisation_address": "Kontakt-Adresse",
    "organisation_legal_explain": "Weiterführende Informationen zur rechtlichen Vertretung",
    "organisation_legal": "Rechtliche Vertretung",
    "organisation_intro_explain": "Weitere Informationen zur Vorstellung der Organisation",
    "organisation_intro": "Vorstellung der Organisation",
    "organisation_meeting_explain": "Text zum Einladen von Vernetzungstreffen",
    "organisation_meeting": "Einladung zu Treffen",
    "organisation_meeting_intro": "Besucht unsere Treffen: ",
    "organisation_home_intro": "Der Leerstandsmelder in {lsm_name} wird betreut von:",
    "missing": {
      "title": "Wo bist du?",
      "intro": "Hilf uns deine Meldung zuzuordnen indem du zuerst eine Region auswählst:"
    },
    "map_lists": {
      "next": "Leerstände im Kartenausschnitt",
      "next_short": "Im Kartenausschnitt",
      "newest": "Aktualisierte/neue Leerstände",
      "newest_short": "Aktualisierte  Einträge",
      "filter": "Leerstände filtern",
      "filter_short": "Leerstände filtern",
      "need": "Leerstände über die Informationen fehlen",
      "need_short": "Braucht Informationen",
      "need_alt": "Geh mal vorbei"
    }
  },
  "site": {
    "name": "Leerstandsmelder",
    "name_neutral": "Leerstandsmelder*in",
    "name_short": "Leer",
    "banned": "Gesperrt",
    "copyright_notice": "© 2024 Leerstandsmelder.de",
    "map_notice": "Karten: © OpenStreetMap contributors, ODbL 1.0",
    "lang": "Sprache",
    "lang_de": "Deutsch",
    "lang_en": "Englisch",
    "lang_nl": "Niederländisch",
    "latest_posts": "Neueste Einträge",
    "no_latest_posts": "Keine Neuesten Einträge",
    "no": "Nein",
    "subnav": {
      "home": "Start",
      "information": "Information",
      "about": "Über uns",
      "developers": "Entwickler*innen",
      "feedback": "Feedback",
      "howto": "So geht's",
      "imprint": "Impressum",
      "index": "Stadtindex",
      "press": "Presse",
      "terms": "AGB",
      "dataprotection": "Datenschutz",
      "region": "Region"
    },
    "title": "Leerstandsmelder"
  },
  "users": {
    "manage_users": "Nutzer*innen verwalten",
    "create_user": "Nutzer*innen erstellen",
    "admin_edit": "Nutzer*innen bearbeiten",
    "admin_create": "Nutzer*innen erstellen",
    "anonymous": "Nicht eingeloggt",
    "email": "E-Mail",
    "forgot": "Passwort vergessen",
    "forgot_enter_email": "Bitte gib deine Email-Adresse an",
    "enter_email": "Email eingeben",
    "request_password": "Passwort anfordern",
    "pwd_change": "Passwort ändern",
    "reset": "Passwort zurücksetzen",
    "enter_new_password": "Bitte gib ein neues Passwort ein",
    "logout": "Abmelden",
    "password": "Passwort",
    "password_enter": "Passwort eingeben!",
    "password_confirm": "Passwort bestätigen",
    "password_submit": "Passwort ändern",
    "destroy": "Konto löschen",
    "destroy_intro": "Du kannst deine Konto jederzeit löschen und damit die Nutzung des Leerstandsmelders beenden. Hierbei werden alle deine personenbezogenen Daten entfernt.",
    "destroy_headline": "Konto löschen",
    "destroy_explain": "Wenn du dein Konto löschen willst, werden alle personen-bezogenen Daten entfernt. Hierunter fallen dein Benutzername, sowie deine Email-Adresse. Die von dir gemeldeten Leerstände & Kommentare unterliegen nicht dem Widerspruch und werden erhalten bleiben.  ",
    "destroy_finally": "Unwiderruflich löschen",
    "destroy_abort": "Löschen abbrechen",
    "settings": "Einstellungen",
    "profile": "Profil",
    "signup": "Registrieren",
    "username": "Benutzername",
    "login_process": "Anmeldung",
    "login_process_explain": "Du musst dich anmelden um mitzumachen.",
    "login_no_account": "Solltest du noch kein Konto haben, geht es hier zum ",
    "login": "Anmelden",
    "message_me": "Andere Nutzer können mir Nachrichten auf Leerstandsmelder schicken.",
    "notify": "Benachrichtige mich per Email wenn meine Einträge aktualisiert werden oder neue Kommentare hinzugefügt werden.",
    "share_email": "Meine Email-Adresse für andere Nutzer*innen sichtbar machen",
    "register_process": "Mitmachen",
    "register": "Registrieren",
    "register_headline": "Konto anlegen",
    "register_process_explain": "Um neue Einträge auf dem Leerstandsmelder zu veröffentlichen, aber auch um neue Kommentare/Status-Meldungen zu bestehenden Einträgen abzugeben musst du ein Konto anlegen. Hierbei fragen wir deine Email-Adresse ab. Wie versuchen so wenige Daten wie möglich über dich zu speichern. Wir wollen euch ermutigen unseren Dienst auch unter einem Pseudonym zu nutzen. Für den Benutzernamen kannst du ein Pseudonym wählen. Deinen Email-Adresse sollte auch keinen Rückschluss auf deinen Namen enthalten.",
    "register_already_account": "Solltest du bereits ein Konto haben, geht es hier zur ",
    "register_message": "Registriere Dich!",
    "all": "Alle Nutzer*innen",
    "confirmed": "Bestättigt",
    "blocked": "Blockiert",
    "last_login": "Letzter login",
    "failed_logins": "Fehlgeschlagene Logins",
    "scope": "Berechtigungen",
    "created": "Angemeldet",
    "accept_no_minor": "Ich versichere das ich über 18 Jahre alt bin.",
    "accept_terms": "Ich habe die AGB gelesen und erkläre mich mit diesen einverstanden.",
    "terms": "Allgemeine Geschäftsbedingungen",
    "update": "Aktualisieren",
    "user_loaded": "Einstellungen wurden geladen",
    "user_places_loaded": "Einträge wurden geladen",
    "user_comments_loaded": "Kommentare wurden geladen",
    "no_locations": "Keine Einträge vorhanden",
    "no_comments": "Keine Kommentare vorhanden"
  },
  "image": {
    "title": "Bild-Unterschrift",
    "uploaded": "Bild wurde hochgeladen."
  },
  "content": {
    "about": {
      "headline": "Hier findest du weiterführende Informationen:",
      "what": "Was ist der Leerstandsmelder?",
      "why": "Warum schadet Leerstand?",
      "claim": "Was sind unsere Forderungen?",
      "how": "Wie kannst du mitmachen?",
      "goodtoknow": "Wissenswertes über Leerstand"
    }
  }
}
